<template>
  <div class="custom-tooltip-wrapper" @mouseenter="show = true" @mouseleave="show = false">
    <slot />
    <div v-if="show" class="custom-tooltip-content">
      <slot name="content">{{ content }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTooltip',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false
    }
  }
}
</script>

<style scoped>
.custom-tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.custom-tooltip-content {
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: #222;
  color: #fff;
  padding: 8px 14px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  font-size: 14px;
  white-space: nowrap;
  z-index: 999;
  min-width: 40px;
  width: auto;
  text-align: left;
  word-break: keep-all;
}
.custom-tooltip-content::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 6px;
  border-style: solid;
  border-color: #222 transparent transparent transparent;
}
</style> 